// components/Features.jsx
import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

import enjoy from "../../assets/icons/icons8-enjoy-64.png";
import image from "../../assets/icons/icons8-photo-gallery-50.png";
import team from "../../assets/icons/icons8-team-50.png";

// ✅ Register AFTER all imports
// gsap.registerPlugin(ScrollTrigger);

const featuresData = [
  {
    icon: image,
    number: 50000,
    suffix: "+",
    label: "Photos Captured",
    title: "Top-Tier Image & Video Quality",
    text: "State-of-the-art cameras and lighting ensure every photo and video is sharp, vibrant, and true to life.",
  },
  {
    icon: enjoy,
    number: 1000,
    suffix: "+",
    label: "Successful Events",
    title: "Seamless Guest Experience",
    text: "An intuitive interface, instant prints, and smooth flow make every guest interaction effortless and fun.",
  },
  {
    icon: team,
    number: 100,
    suffix: "%",
    label: "Client Satisfaction",
    title: "Professional Team",
    text: "Our experienced team handles everything from setup to execution with precision and care.",
  },
];

const Features = () => {
  const sectionRef = useRef(null);
  const cardsRef = useRef([]);
  const numbersRef = useRef([]);
  const iconsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Cards animation
      // gsap.from(cardsRef.current, {
      //   opacity: 0,
      //   y: 40,
      //   duration: 1,
      //   ease: "power3.out",
      //   stagger: 0.2,
      //   scrollTrigger: {
      //     trigger: sectionRef.current,
      //     start: "top 80%",
      //     once: true,
      //   },
      // });

      // Count-up
      numbersRef.current.forEach((el, i) => {
        if (!el) return;
        gsap.fromTo(
          el,
          { innerText: 0 },
          {
            innerText: featuresData[i].number,
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 },
            scrollTrigger: {
              trigger: el,
              start: "top 85%",
              once: true,
            },
          }
        );
      });

      // Icon hover
      iconsRef.current.forEach((icon) => {
        if (!icon) return;
        icon.addEventListener("mouseenter", () =>
          gsap.to(icon, { scale: 1.15, rotate: 5, duration: 0.3 })
        );
        icon.addEventListener("mouseleave", () =>
          gsap.to(icon, { scale: 1, rotate: 0, duration: 0.4 })
        );
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full px-4 py-24 max-w-[1400px] mx-auto"
    >
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-stretch">
        {featuresData.map((feature, index) => (
          <div
            key={index}
            ref={(el) => (cardsRef.current[index] = el)}
            className="flex flex-col items-center text-center p-8 rounded-2xl 
              bg-white/5 backdrop-blur-xl border border-white/10
              shadow-[0_0_30px_rgba(118,207,255,0.08)]
              hover:border-[#76cfff]/50 transition-all duration-300"
          >
            <div
              ref={(el) => (iconsRef.current[index] = el)}
              className="w-[60px] h-[60px] mb-6"
            >
              <img
                src={feature.icon}
                alt={feature.title}
                className="w-full h-full object-contain"
              />
            </div>

            <div className="mb-4">
              <span
                ref={(el) => (numbersRef.current[index] = el)}
                className="text-[#76cfff] font-poppins text-[42px] font-bold"
              >
                0
              </span>
              <span className="text-[#76cfff] font-poppins text-[28px] font-bold">
                {feature.suffix}
              </span>
              <p className="text-white/70 text-sm tracking-widest uppercase mt-1">
                {feature.label}
              </p>
            </div>

            <h3 className="text-white uppercase font-poppins font-semibold text-[22px] mb-4">
              {feature.title}
            </h3>

            <p className="text-white/85 font-poppins text-[16px] font-light leading-relaxed">
              {feature.text}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
